import { PermanentDiscount, TemporaryDiscount } from "@chef/smart-components";
import {
  useExtendedBasketData,
  useLoyalty,
} from "@chef/state-management/hooks";
import { sumByProperty } from "@chef/utils/array";
import { isPickAndMixProduct, isStandaloneProduct } from "@chef/helpers";
import { CurrencyWrapper as Currency } from "@chef/smart-components";
import { getBasketFinances } from "@chef/state-management/helpers";

import type { WeekYear } from "@chef/types/common";

import { intl } from "../pages/WeekEditorConfirmOrderExperimental.Intl";

export const Summary = ({ week, year }: WeekYear) => {
  const { data: loyaltyData } = useLoyalty();

  const { data: extendedBasket } = useExtendedBasketData({ week, year });

  const { selectedProducts = [], portions, deliveryFee } = extendedBasket;
  const meals = selectedProducts.filter(isPickAndMixProduct);

  const standaloneProducts = selectedProducts.filter(isStandaloneProduct) ?? [];

  const numMeals = meals.length ?? 0;
  const numStandaloneProducts = sumByProperty(standaloneProducts, "quantity");
  const finances = getBasketFinances({
    basketProducts: selectedProducts,
    customerFee: deliveryFee,
    loyaltyLevel: loyaltyData?.currentLevel,
  });

  const isBelowMinMeals =
    selectedProducts.filter(isPickAndMixProduct).length <
    extendedBasket.minMeals;

  return (
    <div className="mb-2 ">
      <h2 className="hidden text-lg md:mb-2 md:block">
        <strong>{intl.SUMMARY}</strong>
      </h2>

      <div className="flex flex-col md:gap-2">
        {!isBelowMinMeals && (
          <div className="flex justify-between">
            <span>
              {numMeals} {intl.MEALS}, {portions} {intl.PORTIONS}
            </span>
            <Currency trimDecimal>
              {finances.mealbox + finances.pickAndMix}
            </Currency>
          </div>
        )}

        {!!numStandaloneProducts && (
          <div className="flex justify-between">
            <span>
              {numStandaloneProducts}{" "}
              {numStandaloneProducts > 1 ? intl.ADDONS : intl.ADDON}
            </span>
            <Currency trimDecimal>{finances.addon}</Currency>
          </div>
        )}

        <PermanentDiscount hasDivider={false} />

        <TemporaryDiscount hasDivider={false} />

        <div className="flex justify-between">
          <span>{intl.DELIVERY}</span>

          <Currency trimDecimal>{deliveryFee}</Currency>
        </div>

        {!isBelowMinMeals && (
          <div className="flex justify-between pt-2 mt-2 border-t-grey-3 border-t-1.5 md:border-none md:mt-0 md:pt-0">
            <strong>{intl.TOTAL}</strong>

            <Currency trimDecimal emphasized className="!text-black">
              {finances.total}
            </Currency>
          </div>
        )}
        <p className="ml-auto text-xs text-discount">
          {intl.BEFORE_DISCOUNTS_ARE_APPLIED}
        </p>
      </div>
    </div>
  );
};
